import type { RuntimeEnvironment } from "src/app/Firebase";
import { getDevelopmentTenantId } from "./componentRouteResolver";
import { getMobileComponentStackBaseHref } from "./mobileComponentStackRoutes";

export function getRouterFallbackHref(
  environment: RuntimeEnvironment,
  location: Pick<Location, "search"> = window.location,
) {
  if (environment !== "DEVELOPMENT") {
    return "/";
  }

  const tenantId = getDevelopmentTenantId(
    new URLSearchParams(location.search).get("tenant"),
  );

  return getMobileComponentStackBaseHref(environment, tenantId);
}
